import FormControl from '@material-ui/core/FormControl'
import Select, { SelectProps } from '@material-ui/core/Select'
import ImportExportIcon from '@material-ui/icons/ImportExport'

import { useStyles } from './styles'

export function Root({ 'aria-label': ariaLabel, ...props }: SelectProps) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <ImportExportIcon />
      <p>Ordenar por:</p>

      <FormControl variant='outlined' className={classes.select}>
        <Select
          {...props}
          SelectDisplayProps={{ 'aria-label': ariaLabel }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            elevation: 0,
            classes: {
              paper: classes.paper,
            },
          }}
        />
      </FormControl>
    </div>
  )
}
